import { useEffect, useRef } from 'react';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';

const selector = (s: TrainingState) => select(s, 'auditoryFeedback');

export function useAudioEffect(narration?: string, loop?: boolean) {
  const { auditoryFeedback } = useTrainingStore(selector);

  const audioRef = useRef<HTMLAudioElement>();

  useEffect(() => {
    const audio = new Audio(narration);
    audio.load();
    if (loop) {
      audio.loop = true;
    }
    audioRef.current = audio;
  }, []);

  const play = () => {
    if (!auditoryFeedback || !audioRef.current) {
      return null;
    }
    return audioRef.current.play().catch(() => {
      // Silently ignore autoplay restrictions
    });
  };
  const pause = () => {
    return auditoryFeedback ? audioRef?.current?.pause() : null;
  };

  return [play, pause];
}
